import ButtonExtra from '@/components/ButtonExtra';
import SearchPanel from '@/components/SearchPanel';
import { TipoItemComplementar } from '@/features/prescricao-livre/models';
import PrescricaoLivreService, {
  ItemComplementarSearchResult,
} from '@/features/prescricao-livre/services/PrescricaoLivreService';

import React from 'react';

// import { Container } from './styles';

export type SearchItemComplementarCallback = (
  term: string,
) => Promise<ItemComplementarSearchResult[]>;

interface Props {
  title?: string;
  searchType?: TipoItemComplementar;
  onAdd: (item: ItemComplementarSearchResult) => void;
  onSearch?: SearchItemComplementarCallback;
}

const AddItemComplementar: React.FC<Props> = ({
  title = 'Adicionar item complementar',
  searchType,
  onAdd,
  onSearch,
}) => {
  const [mode, setMode] = React.useState<'add' | 'search'>('add');
  const [loading, setLoading] = React.useState(false);
  const [results, setResults] = React.useState<
    ItemComplementarSearchResult[] | undefined
  >(undefined);

  const defaultSearch = React.useCallback(
    (term: string) => {
      if (!searchType) {
        throw new Error('Tipo de busca não fornecido');
      }

      return PrescricaoLivreService.search({
        term,
        type: searchType,
      });
    },
    [searchType],
  );

  const searchItems = React.useCallback(
    async (term: string) => {
      try {
        setLoading(true);

        const callback = onSearch || defaultSearch;

        const searchResults = await callback(term);
        setResults(searchResults);
        // eslint-disable-next-line no-empty
      } catch {
      } finally {
        setLoading(false);
      }
    },
    [onSearch, defaultSearch],
  );

  const clear = React.useCallback(() => {
    setResults(undefined);
  }, []);

  const handleItemSelect = React.useCallback(
    (result: ItemComplementarSearchResult) => {
      if (onAdd) {
        onAdd(result);
      }
      setMode('add');

      clear();
    },
    [clear, onAdd],
  );

  if (mode === 'search') {
    return (
      <SearchPanel
        autoFocus
        placeholder="Busque aqui"
        results={results}
        searching={loading}
        debounceTimeInMS={600}
        resultLabel={({ item }) => item.label}
        resultKeyExtractor={({ item }) => item.value}
        onSearch={searchItems}
        onResultSelect={handleItemSelect}
        onResultsDismiss={() => {
          clear();
        }}
        onSearchFocusOut={() => {
          clear();
        }}
      />
    );
  }

  return <ButtonExtra onClick={() => setMode('search')}>{title}</ButtonExtra>;
};

export default AddItemComplementar;
